<div class="intake-content">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-12">
        <div class="intake-form-wrapper">
          <!-- Header -->
          <div class="form-header mb-4">
            <span class="form-label-header">INTAKE FORM</span>
            <h1 class="form-title">Help us serve you better</h1>
          </div>

          <!-- Form -->
          <form class="intake-form" (ngSubmit)="onSubmit(intakeFormRef)" #intakeFormRef="ngForm">
            <!-- Name -->
            <div class="form-group mb-4">
              <label for="name" class="form-label">
                Name <span class="required">*</span>
              </label>
              <input 
                type="text" 
                id="name"
                name="name"
                class="form-control form-input"
                [class.error]="hasError('name')"
                placeholder="Jane Smith"
                [(ngModel)]="intakeForm.name"
                (input)="onFieldChange('name')"
                (blur)="onFieldBlur('name')"
                required
              />
              <div class="error-message" *ngIf="hasError('name')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('name') }}
              </div>
            </div>

            <!-- Email -->
            <div class="form-group mb-4">
              <label for="email" class="form-label">
                Email address <span class="required">*</span>
              </label>
              <input 
                type="email" 
                id="email"
                name="email"
                class="form-control form-input"
                [class.error]="hasError('email')"
                placeholder="email@website.com"
                [(ngModel)]="intakeForm.email"
                (input)="onFieldChange('email')"
                (blur)="onFieldBlur('email')"
                required
                email
              />
              <div class="error-message" *ngIf="hasError('email')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('email') }}
              </div>
            </div>

            <!-- Services -->
            <div class="form-group mb-4">
              <label class="form-label">
                What services are you interested in? <span class="required">*</span>
              </label>
              <div class="checkbox-group">
                <div 
                  id="services"
                  class="form-check mb-2" 
                  *ngFor="let service of serviceOptions"
                >
                  <input 
                    type="checkbox" 
                    class="form-check-input"
                    [id]="'service-' + service"
                    [class.error]="hasError('services')"
                    [checked]="isServiceSelected(service)"
                    (change)="onServiceChange(service, $event)"
                  />
                  <label 
                    class="form-check-label" 
                    [for]="'service-' + service"
                  >
                    {{ service }}
                  </label>
                </div>
              </div>
              <div class="error-message" *ngIf="hasError('services')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('services') }}
              </div>
            </div>

            <!-- Budget Range -->
            <div class="form-group mb-4">
              <label for="budget" class="form-label">
                What is your budget range? <span class="required">*</span>
              </label>
              <select 
                id="budget"
                name="budget"
                id="budgetRange"
                class="form-control form-select"
                [class.error]="hasError('budgetRange')"
                [(ngModel)]="intakeForm.budgetRange"
                (change)="onFieldChange('budgetRange')"
                (blur)="onFieldBlur('budgetRange')"
                required
              >
                <option value="">Select</option>
                <option 
                  *ngFor="let option of budgetOptions" 
                  [value]="option"
                >
                  {{ option }}
                </option>
              </select>
              <div class="error-message" *ngIf="hasError('budgetRange')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('budgetRange') }}
              </div>
            </div>

            <!-- Industry -->
            <div class="form-group mb-4">
              <label for="industry" class="form-label">
                What is your industry? <span class="required">*</span>
              </label>
              <select 
                id="industry"
                name="industry"
                class="form-control form-select"
                [(ngModel)]="intakeForm.industry"
                [class.error]="hasError('industry')"
                (change)="onFieldChange('industry')"
                (blur)="onFieldBlur('industry')"
                required
              >
                <option value="">Select</option>
                <option 
                  *ngFor="let option of industryOptions" 
                  [value]="option"
                >
                  {{ option }}
                </option>
              </select>
              <div class="error-message" *ngIf="hasError('industry')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('industry') }}
              </div>
            </div>

            <!-- How did you hear about us -->
            <div class="form-group mb-4">
              <label for="hearAbout" class="form-label">
                How did you hear about us? <span class="required">*</span>
              </label>
              <select 
                id="hearAbout"
                name="hearAbout"
                class="form-control form-select"
                [(ngModel)]="intakeForm.hearAboutUs"
                [class.error]="hasError('hearAboutUs')"
                (change)="onFieldChange('hearAboutUs')"
                (blur)="onFieldBlur('hearAboutUs')"
                required
              >
                <option value="">Select</option>
                <option 
                  *ngFor="let option of hearAboutOptions" 
                  [value]="option"
                >
                  {{ option }}
                </option>
              </select>
              <div class="error-message" *ngIf="hasError('hearAboutUs')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('hearAboutUs') }}
              </div>
            </div>

            <!-- Timeline -->
            <div class="form-group mb-4">
              <label for="timeline" class="form-label">
                What is your timeline for this project? <span class="required">*</span>
              </label>
              <select 
                id="timeline"
                name="timeline"
                class="form-control form-select"
                [(ngModel)]="intakeForm.timeline"
                [class.error]="hasError('timeline')"
                (change)="onFieldChange('timeline')"
                (blur)="onFieldBlur('timeline')"
                required
              >
                <option value="">Select</option>
                <option 
                  *ngFor="let option of timelineOptions" 
                  [value]="option"
                >
                  {{ option }}
                </option>
              </select>
              <div class="error-message" *ngIf="hasError('timeline')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('timeline') }}
              </div>
            </div>

            <!-- Current Website -->
            <div class="form-group mb-4">
              <label for="website" class="form-label">
                Do you have a current website? <span class="required">*</span>
              </label>
              <select 
                id="website"
                name="website"
                class="form-control form-select"
                [(ngModel)]="intakeForm.currentWebsite"
                [class.error]="hasError('currentWebsite')"
                (change)="onFieldChange('currentWebsite')"
                (blur)="onFieldBlur('currentWebsite')"
                required
              >
                <option value="">Select</option>
                <option 
                  *ngFor="let option of websiteOptions" 
                  [value]="option"
                >
                  {{ option }}
                </option>
              </select>
              <div class="error-message" *ngIf="hasError('currentWebsite')">
                <i class="bi bi-exclamation-circle me-1"></i>
                {{ getErrorMessage('currentWebsite') }}
              </div>
            </div>

            <!-- Additional Comments -->
            <div class="form-group mb-4">
              <label for="comments" class="form-label">Additional questions or comments</label>
              <textarea 
                id="comments"
                name="comments"
                class="form-control form-textarea"
                rows="5"
                placeholder="Enter any additional questions or comments..."
                [(ngModel)]="intakeForm.additionalComments"
              ></textarea>
            </div>

            <!-- Honeypot field - hidden from users -->
            <div class="honeypot-field">
              <label for="organization" class="visually-hidden">Organization (leave blank)</label>
              <input 
                type="text" 
                id="organization"
                name="organization"
                class="form-control"
                [(ngModel)]="intakeForm.honeypot"
                tabindex="-1"
                autocomplete="off"
              />
            </div>

            <!-- Submit Button -->
            <div class="form-group">
              <button 
                type="submit" 
                class="btn submit-btn w-100"
                [disabled]="isSubmitDisabled()"
                [class.loading]="isSubmitting"
              >
                {{ getSubmitButtonText() }}
              </button>

              <div class="submit-message mt-3" *ngIf="submitMessage" [class.success]="!isSubmitting">
                {{ submitMessage }}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>